import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { ContentHeader } from "../../components";
import { layDuLieuThuNhapQuyetToan } from "../../services/luong";
import { toast } from "react-toastify";
import { Button, Checkbox, Col, DatePicker, Form, Row, Space, Table, Tabs } from "antd";
import { dateCommon, formatVND, formatVNDNoFractionDigit, tinhThueTNCNTheoThang, validateMessages } from '../../helpers/common';
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { DuLieuQuyetToanThueResponse } from '../../models/thue/Thue';
import dayjs from 'dayjs';
import { Tag } from 'antd/lib';
import { useNavigate } from 'react-router-dom';
import { ColumnsType } from 'antd/es/table';
import { Links } from '@app/helpers/Links';
import { layChiTietQuyetToanThueThuongXuyen, luuQuyetToanThue } from '../../services/thue';

const ChiTietQuyetToanThueThuongXuyen = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [saveButton, setSaveButton] = useState<boolean>(false);
    const [form] = Form.useForm();
    const [dataThueTNCN, setDataThueTNCN] = useState<Array<DuLieuQuyetToanThueResponse>>([]);
    const dispatch = useDispatch();
    const [khoaDieuChinh, setKhoaDieuChinh] = useState<boolean>(false);
    const [idThueThang, setIdThueThang] = useState<number>(0);
    const [trangThai, setTrangThai] = useState<number>(-1);    

    const layDuLieu = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                setIsLoading(true);
                const nam = values?.thoiGianThueThang?.$y;
                let rs = await layDuLieuThuNhapQuyetToan(nam);
                setDataThueTNCN(rs);
                setSaveButton(true);
                setIsLoading(false);
            } catch (error: any) {
                toast.error(error?.message || 'Có lỗi xảy ra. Vui lòng thử lại sau.');
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Vui lòng chọn năm muốn quyết toán thuế");
        });
    }

    const eventSaveQuyetToanThue = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                const nam = form.getFieldsValue(['thoiGianThueThang']).thoiGianThueThang.$y;
                var request = {
                    idQuyetToanThue: idThueThang,
                    nam: nam,
                    dsThues: dataThueTNCN,
                    khoaDieuChinh: khoaDieuChinh === true ? 1 : 0,
                };

                const data = await luuQuyetToanThue(request);

                if (data != 0) {
                    toast.success(`Lưu quyết toán thuế năm ${nam} thành công`);
                    if (!khoaDieuChinh) {
                        setSaveButton(true);
                    } else {

                        setSaveButton(false);
                    }
                    setTrangThai(khoaDieuChinh === true ? 1 : 0);
                    if (idThueThang == 0) {
                        navigate(`${Links.Thue.ChiTietQuyetToanThuongXuyen}?id=${data}`);
                    }
                }
            } catch (error: any) {
                toast.error(error?.message || 'Có lỗi xảy ra. Vui lòng thử lại sau.');
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Vui lòng chọn năm muốn quyết toán");
        });
    }    

    const layQuyetToanThue = async (id: number) => {
        try {
            setIsLoading(true);
            var data = await layChiTietQuyetToanThueThuongXuyen(id);
            form.setFieldsValue({
                thoiGianThueThang: dayjs(dateCommon.formatDate(new Date(data.nam, 6, 1), "MM/yyyy"), "YYYY")
            });
            
            setTrangThai(data?.khoaDieuChinh);

            setDataThueTNCN(data.dataChiTietThueNamResponses);
            if (data?.khoaDieuChinh == 0) {
                setSaveButton(true);
            }
        } catch (e) {
            toast.error("Không thể lấy thông tin bảng quyết toán thuế");
        }
        setIsLoading(false);
    }

    const dynamicColumnPhatSinhs = dataThueTNCN?.length > 0 ? (dataThueTNCN?.find(x => x?.thuNhapChiuThuePhatSinh?.length === Math.max(...dataThueTNCN?.map(y => y?.thuNhapChiuThuePhatSinh?.length))) || dataThueTNCN[0]).thuNhapChiuThuePhatSinh?.map((item) => ({
        title: item?.tenThuNhap,
        dataIndex: `thuNhapChiuThuePhatSinh_${item?.tenThuNhap}`,
        key: `thuNhapChiuThuePhatSinh_${item?.tenThuNhap}`,
        className: 'custom-column',
        render: (text: any, record: DuLieuQuyetToanThueResponse) => formatVND(record?.thuNhapChiuThuePhatSinh?.find((i) => i?.tenThuNhap === item?.tenThuNhap)?.mucThuNhap),
    })) : [];

    const dynamicColumnGiamTrus = dataThueTNCN?.length > 0 ? (dataThueTNCN?.find(x => x?.cacKhoanGiamTru?.length === Math.max(...dataThueTNCN?.map(y => y.cacKhoanGiamTru?.length))) || dataThueTNCN[0]).cacKhoanGiamTru?.map((item) => ({
        title: item?.tenThuNhap,
        dataIndex: `cacKhoanGiamTru_${item?.tenThuNhap}`,
        key: `cacKhoanGiamTru_${item?.tenThuNhap}`,
        className: 'custom-column',
        render: (text: any, record: DuLieuQuyetToanThueResponse) => item?.tenThuNhap !== "Số người phụ thuộc" ? formatVND(record?.cacKhoanGiamTru.find((i) => i?.tenThuNhap === item?.tenThuNhap)?.mucThuNhap) : record?.cacKhoanGiamTru.find((i) => i?.tenThuNhap === item?.tenThuNhap)?.mucThuNhap,
    })) : [];

    const dynamicColumnThueDaNops = dataThueTNCN?.length > 0 ? (dataThueTNCN?.find(x => x?.dsThueTNCNDaNop?.length === Math.max(...dataThueTNCN?.map(y => y.dsThueTNCNDaNop?.length))) || dataThueTNCN[0]).dsThueTNCNDaNop?.map((item) => ({
        title: item?.tenThuNhap,
        dataIndex: `dsThueTNCNDaNop_${item?.tenThuNhap}`,
        key: `dsThueTNCNDaNop_${item?.tenThuNhap}`,
        className: 'custom-column',
        render: (text: any, record: DuLieuQuyetToanThueResponse) => item?.tenThuNhap !== "Số người phụ thuộc" ? formatVND(record?.dsThueTNCNDaNop.find((i) => i?.tenThuNhap === item?.tenThuNhap)?.mucThuNhap) : record?.dsThueTNCNDaNop.find((i) => i?.tenThuNhap === item?.tenThuNhap)?.mucThuNhap,
    })) : [];

    const columns: ColumnsType<DuLieuQuyetToanThueResponse> = [
        { title: 'Họ Tên', dataIndex: 'hoTen', key: 'hoTen', fixed: 'left' },
        { title: 'Chức vụ', dataIndex: 'tenChucVu', key: 'tenChucVu', fixed: 'left' },
        {
            title: 'Thu nhập chịu thuế',
            children: dynamicColumnPhatSinhs
        },
        {
            title: 'Tổng thu nhập chịu thuế',
            dataIndex: 'tongThuNhapChiuThue',
            key: 'tongThuNhapChiuThue',
            className: 'custom-column',
            render: (text: number) => formatVND(text),
        },
        {
            title: 'Các khoản giảm trừ',
            children: dynamicColumnGiamTrus,
        },
        {
            title: 'Tổng cộng giảm trừ',
            dataIndex: 'tongCongGiamTru',
            key: 'tongCongGiamTru',
            className: 'custom-column',
            render: (text: number) => formatVND(text),
        },
        {
            title: 'Thu nhập tính thuế TNCN',
            dataIndex: 'thuNhapTinhThueTNCN',
            key: 'thuNhapTinhThueTNCN',
            className: 'custom-column',
            render: (text: number) => formatVND(text),
        },
        {
            title: 'Thuế TNCN phải nộp',
            dataIndex: 'thuePhaiNop',
            key: 'thuePhaiNop',
            className: 'custom-column',
            render: (text: number) => formatVND(text.toFixed(0)),
        },
        {
            title: 'Thuế TNCN đã nộp',
            children: dynamicColumnThueDaNops,
        },
        {
            title: 'Thuế TNCN còn phải nộp',
            dataIndex: 'thueConPhaiNop',
            key: 'thueConPhaiNop',
            className: 'custom-column',
            render: (text: number) => formatVND(text.toFixed(0)),
        },
        {
            title: 'Thuế TNCN được hoàn trả',
            dataIndex: 'thueDuocHoanTra',
            key: 'thueDuocHoanTra',
            className: 'custom-column',
            render: (text: number) => formatVND(text.toFixed(0)),
        },
        {
            title: 'Ủy quyền QT',
            dataIndex: 'uyQuyenQT',
            key: 'uyQuyenQT',
            align: "center",
            render: (uyQuyenQT: boolean, record: DuLieuQuyetToanThueResponse, index: number) =>
                <Checkbox checked={uyQuyenQT} onChange={(e) => {
                    if (e.target.checked) {
                        const tongThueDaNopItem = dataThueTNCN[index].dsThueTNCNDaNop.find((x) => x.tenThuNhap == "Tổng cộng thuế đã nộp");
                        const tongThueDaNopMucTien = tongThueDaNopItem?.mucThuNhap || 0;
                        dataThueTNCN[index].thuePhaiNop = tinhThueTNCNTheoThang(dataThueTNCN[index].thuNhapTinhThueTNCN);
                        dataThueTNCN[index].thueConPhaiNop = dataThueTNCN[index].thuePhaiNop > tongThueDaNopMucTien ? dataThueTNCN[index].thuePhaiNop - tongThueDaNopMucTien : 0;
                        dataThueTNCN[index].thueDuocHoanTra = tongThueDaNopMucTien > dataThueTNCN[index].thuePhaiNop ? tongThueDaNopMucTien - dataThueTNCN[index].thuePhaiNop : 0;
                        dataThueTNCN[index].uyQuyenQT = e.target.checked;
                        setDataThueTNCN([...dataThueTNCN]);
                    }
                    else {
                        dataThueTNCN[index].thuePhaiNop = 0;
                        dataThueTNCN[index].thueConPhaiNop = 0;
                        dataThueTNCN[index].thueDuocHoanTra = 0;
                        dataThueTNCN[index].uyQuyenQT = e.target.checked;
                        setDataThueTNCN([...dataThueTNCN]);
                    }
                }
            } />,
        },
    ];

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = +(params.get('id') || '');
        setIdThueThang(+id);
    }, []);

    useEffect(() => {
        if (idThueThang > 0) {
            layQuyetToanThue(idThueThang);
        }
    }, [idThueThang]);

    var tag = (<Tag color="default"></Tag>);
    switch (trangThai) {
        case 0: tag = (<Tag color="success">Mở khóa</Tag>); break;
        case 1: tag = (<Tag color="red">Khóa điều chỉnh</Tag>); break;
    }

    return <section>
        <ContentHeader title="Quyết toán Thuế TNCN" />
        <Tabs
            tabBarExtraContent={
                saveButton ? <Space>
                    <Button
                        loading={isLoading}
                        type="primary"
                        icon={<SaveOutlined rev="" />}
                        onClick={eventSaveQuyetToanThue}
                    >
                        Lưu quyết toán thuế
                    </Button>
                </Space> : null}
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: "Quyết toán Thuế TNCN",
                    children:
                        <Row>
                            <Col span="24" className="card card-body">
                                <Form
                                    layout="vertical"
                                    validateMessages={validateMessages}
                                    form={form}
                                    onFinish={layDuLieu}
                                >
                                    <Row gutter={12}>
                                        <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                },
                                            ]} label="Thời gian" name="thoiGianThueThang">
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={trangThai >= 0}
                                                    style={{ width: "100%" }}
                                                    format={["YYYY", "YYYY"]}
                                                    placeholder="Chọn thời gian"
                                                    picker="year" />
                                            </Form.Item>
                                        </Col>
                                        {
                                            trangThai >= 0 &&
                                            <Col span="12">
                                                <Form.Item label="Trạng thái">
                                                    <label>{tag}</label>
                                                </Form.Item>
                                            </Col>
                                        }
                                    </Row>
                                    <Row>
                                        {trangThai <= 0 &&
                                            <Space>
                                                <Form.Item>
                                                    <Button type="primary" className="float-right" htmlType="submit" loading={isLoading} icon=<ReloadOutlined rev="" />>
                                                        Tải dữ liệu quyết toán thuế TNCN
                                                    </Button>
                                                </Form.Item>
                                            </Space>}
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                }]} />
        <div className="card card-primary mt-2">
            {(dataThueTNCN != null && dataThueTNCN.length > 0 && saveButton) &&
                <div className="p-4">
                    <Row>
                        <Col span="6">
                            <Checkbox checked={khoaDieuChinh} onChange={(e) => setKhoaDieuChinh(e.target.checked)} >Khóa điều chỉnh</Checkbox>
                        </Col>
                    </Row>
                </div>}
            <Table
                pagination={false}
                dataSource={dataThueTNCN.map((x: any, idx: any) => { return { ...x, key: idx } })}
                loading={isLoading}
                columns={columns}
                sticky
                bordered
                scroll={{ x: 6500 }}
                locale={{ emptyText: "Không có dữ liệu" }}
                summary={pageData => {
                    var totalthuePhaiNop = 0;
                    var totalthueConPhaiNop = 0;
                    var totalthueDuocHoanTra = 0;
                    var totalThuNhapTinhThueTNCN = 0;
                    var totalTongCongGiamTru = 0;
                    var totalTongThuNhapChiuThue = 0;
                    var dataPhatSinh: number[] = [];
                    var dataGiamTru: number[] = [];
                    var dataDaNop: number[] = [];
                    var resultArray: number[] = [];
                    const totalByType: { [key: string]: number } = {};


                    pageData.forEach(({ thuePhaiNop, thuNhapTinhThueTNCN, tongCongGiamTru, tongThuNhapChiuThue, cacKhoanGiamTru, thuNhapChiuThuePhatSinh, dsThueTNCNDaNop, thueConPhaiNop, thueDuocHoanTra }) => {
                        totalThuNhapTinhThueTNCN += thuNhapTinhThueTNCN;
                        totalthuePhaiNop += thuePhaiNop;
                        totalthueConPhaiNop += thueConPhaiNop;
                        totalthueDuocHoanTra += thueDuocHoanTra;
                        totalTongCongGiamTru += tongCongGiamTru;
                        totalTongThuNhapChiuThue += tongThuNhapChiuThue;

                        cacKhoanGiamTru.forEach((item: any) => {
                            const { tenThuNhap, mucThuNhap } = item;
                            totalByType[tenThuNhap] = (totalByType[tenThuNhap] || 0) + mucThuNhap;
                        });

                        resultArray = Object.values(totalByType);

                        thuNhapChiuThuePhatSinh?.forEach((item: any, idx: number) => {
                            if (dataPhatSinh.length - 1 < idx) {
                                dataPhatSinh.push(0);
                            }

                            dataPhatSinh[idx] += item.mucThuNhap;
                        });

                        cacKhoanGiamTru?.forEach((item: any, idx: number) => {
                            if (dataGiamTru.length - 1 < idx) {
                                dataGiamTru.push(0);
                            }

                            if (item.tenThuNhap == cacKhoanGiamTru[0].tenThuNhap) {
                                dataGiamTru[idx] += item.mucThuNhap;
                            }
                        });

                        dsThueTNCNDaNop?.forEach((item: any, idx: number) => {
                            if (dataDaNop.length - 1 < idx) {
                                dataDaNop.push(0);
                            }

                            dataDaNop[idx] += item.mucThuNhap;
                        });
                    });


                    var length1 = dataPhatSinh.length;
                    var length2 = dataGiamTru.length;
                    var length3 = dataDaNop.length;

                    return (
                        <>
                            <Table.Summary.Row key="summary-row">
                                <Table.Summary.Cell index={0} key="1" colSpan={2} align="left"> <label>Tổng cộng</label> </Table.Summary.Cell>
                                {dataPhatSinh.length > 0 &&
                                    <>
                                        {dataPhatSinh.map((item: number, idx: number) => (
                                            <Table.Summary.Cell key={2 + idx} index={2 + idx} align="right"><label> {formatVND(item)}</label></Table.Summary.Cell>
                                        ))}
                                    </>
                                }
                                <Table.Summary.Cell key={3 + length1} index={3 + length1} align="right"> <label>{formatVND(totalTongThuNhapChiuThue) || "-"} </label> </Table.Summary.Cell>
                                {dataGiamTru.length > 0 &&
                                    <>
                                        {resultArray.map((item: number, idx: number) => (
                                            <Table.Summary.Cell key={4 + length1 + idx}  index={4 + length1 + idx} align="right"><label> {item < 2000 ? item : formatVND(item)}</label></Table.Summary.Cell>
                                        ))}
                                    </>
                                }
                                <Table.Summary.Cell key={5 + length1 + length2} index={5 + length1 + length2} align="right"> <label>{formatVND(totalTongCongGiamTru) || "-"} </label> </Table.Summary.Cell>
                                <Table.Summary.Cell key={6 + length1 + length2} index={6 + length1 + length2} align="right"> <label>{formatVND(totalThuNhapTinhThueTNCN) || "-"} </label> </Table.Summary.Cell>
                                <Table.Summary.Cell key={7 + length1 + length2} index={7 + length1 + length2} align="right"> <label>{formatVNDNoFractionDigit(totalthuePhaiNop) || "-"} </label> </Table.Summary.Cell>
                                {dataDaNop.length > 0 &&
                                    <>
                                        {dataDaNop.map((item: number, idx: number) => (
                                            <Table.Summary.Cell key={8 + length1 + length2 + idx} index={8 + length1 + length2 + idx} align="right"><label> {item < 2000 ? item : formatVND(item)}</label></Table.Summary.Cell>
                                            ))}
                                    </>
                                }
                                <Table.Summary.Cell key={9 + length1 + length2 + length3} index={9 + length1 + length2 + length3} align="right"> <label>{formatVNDNoFractionDigit(totalthueConPhaiNop) || "-"} </label> </Table.Summary.Cell>
                                <Table.Summary.Cell key={10 + length1 + length2 + length3} index={10 + length1 + length2 + length3} align="right"> <label>{formatVNDNoFractionDigit(totalthueDuocHoanTra) || "-"} </label> </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
            />
        </div>
    </section >
}

export default ChiTietQuyetToanThueThuongXuyen;